import React, { ContextType, useContext } from "react";

import { Box, CardMedia, IconButton, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { getLocalizedName } from "i18n/i18nUtility";
import { useTranslation } from "react-i18next";

import Price from "components/Price/Price";
import { AppContext } from "contexts/AppContext";
import CartContext from "contexts/CartContext";

const useStyles = makeStyles(theme => {
	return {
		card: {
			display: "flex",
			width: "100%",
			margin: theme.spacing(0.5),
			marginBottom: theme.spacing(2),
			borderRadius: 8
		},
		cardAction: {
			borderRadius: 8,
			backgroundColor: "#F2F2F2", //theme.palette.background.paper,
			minHeight: 70,
			maxHeight: 100,
			padding: theme.spacing(1),
			paddingLeft: theme.spacing(4),
			paddingRight: theme.spacing(2),
			display: "flex",
			flexDirection: "column"
		},
		itemName: {
			top: 10,
			fontSize: 16,
			fontWeight: 500,
			textOverflow: "ellipsis"
		},
		price: {
			fontSize: 16
		},
		image: {},
		itemCode: {},
		itemRow: {
			width: "100%",
			display: "flex",
			flex: 1,
			fontWeight: "bold",
			flexDirection: "row",
			justifyContent: "space-between"
		},
		totalRow: {
			width: "100%",
			display: "flex",
			flex: 1,
			flexDirection: "row",
			alignContent: "flex-end",
			justifyContent: "flex-end"
		},
		total: {
			fontWeight: 500
		},
		remove: {
			position: "absolute",
			top: 10,
			left: 15,
			flex: 0.1,
			padding: 5,
			marginLeft: -10,
			textAlign: "left",
			alignSelf: "flex-start"
		}
	};
});

interface CartItemProps {
	props?: any;
	cartItem: ContextType<typeof CartContext>["cartItems"][number];
}

const CartItem: React.FC<CartItemProps> = ({ cartItem }) => {
	const classes = useStyles();
	const { t } = useTranslation();
	const { locale } = useContext(AppContext);

	const { menuItem } = cartItem;

	const onRemoveItemClicked = e => {
		// removeFromCart(cartItem.cartItemId);
	};

	return (
		<Paper elevation={0} className={classes.card}>
			<Box className={classes.cardAction}>
				<Box className={classes.itemRow}>
					<IconButton onClick={onRemoveItemClicked} className={classes.remove}></IconButton>
					{menuItem.imageUrl && (
						<Box className={classes.image}>
							<CardMedia image={menuItem.imageUrl}></CardMedia>
						</Box>
					)}
					<Typography className={classes.itemName}>
						{getLocalizedName(locale, menuItem.localeNames, menuItem.name)}
					</Typography>
					<Typography className={classes.itemCode}>{menuItem.itemCode}</Typography>
					<Price className={classes.price} priceCents={cartItem.extendedPriceCents} />
				</Box>
				<Box className={classes.totalRow}>
					<Price className={classes.total} priceCents={cartItem.extendedPriceCents} />
				</Box>
			</Box>
		</Paper>
	);
};

export default CartItem;
